import React, {FC} from 'react';
import  './index.scss';

interface CustomDataEmptyProps {
    value: string;
    className?: string;
}


export const CustomDataEmpty: FC<CustomDataEmptyProps> = ({value, className}) => {
    return (
        <div className={`customDataEmpty ${className}`}>
            <div className={'customDataEmpty__box'}>
                <span className={'customDataEmpty__box-text'}>{value}</span>
            </div>
        </div>
    );
};
